export default "__VITE_ASSET__H5ZAXDes__"